import React from 'react';
import { Check } from 'lucide-react';

/**
 * Step indicator ported from the mockups (Free_account_study.html /
 * pay_per_study.html): 28px numbered circles with a connector line. Steps
 * before the current one render "done" (emerald + check); the current step is
 * the teal accent; later steps are inactive outlines.
 *
 * This is a PURE progress indicator — it is intentionally NOT clickable. Back
 * navigation is owned by a single BackLink per screen so there's exactly one
 * way to go back (no competing affordances).
 */
const StepIndicator: React.FC<{
  step: number;
  labels: string[];
}> = ({ step, labels }) => (
  <div className="mb-8 flex items-center">
    {labels.map((label, i) => {
      const n = i + 1;
      const done = n < step;
      const active = n === step;
      return (
        <React.Fragment key={label}>
          <div className="flex items-center gap-2">
            <span
              className={[
                'flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-[12px] font-medium transition-colors',
                done
                  ? 'bg-emerald-600 text-white'
                  : active
                  ? 'bg-primary text-white'
                  : 'border-[1.5px] border-black/20 bg-white text-[#6b6b6b]',
              ].join(' ')}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : n}
            </span>
            <span
              className={`text-[13px] font-medium ${active || done ? 'text-[#111]' : 'text-[#6b6b6b]'}`}
            >
              {label}
            </span>
          </div>
          {i < labels.length - 1 && (
            <span className={`mx-3 h-px w-10 ${done ? 'bg-emerald-600' : 'bg-black/20'}`} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default StepIndicator;
